@if (isLeftSidebarVisible()) {
    <sb-sidenav class="left-panel" data-testid="inbox-ui-left-sidebar">
        <app-left-menu></app-left-menu>
    </sb-sidenav>
}

<div class="page-content" [class.ps-0]="!sideNavigationService.isLeftMenuOpen || !isLeftSidebarVisible()">
    <app-top-menu [searchQuery]="commonDataService.searchQuery"></app-top-menu>

    <nav class="navbar navbar-expand navbar-sub">
        <ul class="navbar-nav">
            <li class="nav-item" [ngClass]="{ active: activeStatus === ticketStatusEnum.open }">
                <a
                    [routerLink]="['/', communityName, 'tickets']"
                    [queryParams]="{ status: ticketStatusEnum.open, ticketId: '' }"
                    queryParamsHandling="merge">
                    <div (click)="checkLinkClick($event)" class="nav-link link-content-wrapper" translate>Open</div>
                </a>
            </li>
            @if (isTicketStatusFilterVisible('pending')) {
                <li
                    class="nav-item"
                    data-testid="inbox-ui-ticket-status-filter-pending"
                    [ngClass]="{ active: activeStatus === ticketStatusEnum.pending }">
                    <a
                        [routerLink]="['/', communityName, 'tickets']"
                        [queryParams]="{ status: ticketStatusEnum.pending, ticketId: '' }"
                        queryParamsHandling="merge">
                        <div (click)="checkLinkClick($event)" class="nav-link link-content-wrapper" translate>
                            Pending
                        </div>
                    </a>
                </li>
            }
            @if (isTicketStatusFilterVisible('closed')) {
                <li
                    class="nav-item"
                    data-testid="inbox-ui-ticket-status-filter-closed"
                    [ngClass]="{ active: activeStatus === ticketStatusEnum.completed }">
                    <a
                        [routerLink]="['/', communityName, 'tickets']"
                        [queryParams]="{ status: ticketStatusEnum.completed, ticketId: '' }"
                        queryParamsHandling="merge">
                        <div (click)="checkLinkClick($event)" class="nav-link link-content-wrapper" translate>
                            Closed
                        </div>
                    </a>
                </li>
            }
            @if (isTicketStatusFilterVisible('all')) {
                <li
                    class="nav-item"
                    data-testid="inbox-ui-ticket-status-filter-all"
                    [ngClass]="{
                        active: !activeStatus || activeStatus === ticketStatusEnum.notCompleted,
                    }">
                    <a
                        [routerLink]="['/', communityName, 'tickets']"
                        [queryParams]="{ status: ticketStatusEnum.notCompleted, ticketId: '' }"
                        queryParamsHandling="merge">
                        <div (click)="checkLinkClick($event)" class="nav-link link-content-wrapper" translate>All</div>
                    </a>
                </li>
            }
        </ul>

        <div class="vertical-divider"></div>

        <div class="text-center" style="min-width: 77px">
            <div [hidden]="!isLoadingTickets">
                <small>{{ lastTicketsLength ? '1' : '0' }}</small>
                <small [hidden]="!lastTicketsLength">
                    - {{ lastTicketsLength }} of {{ showResultsCount | shortNumber }}</small
                >
            </div>
            <div [hidden]="isLoadingTickets" style="white-space: nowrap">
                <small>{{ tickets.length ? '1' : '0' }}</small>
                <small [hidden]="!tickets.length">
                    - {{ tickets.length }} of {{ showResultsCount | shortNumber }}</small
                >
            </div>
        </div>
        <div class="vertical-divider"></div>

        @if (isTicketSortingDropdownVisible()) {
            <div class="select-container sort-tickets-select" data-testid="inbox-ui-ticket-sorting-dropdown">
                <ng-select
                    [searchable]="false"
                    [clearable]="false"
                    class="form-control order-by"
                    [ngClass]="{
                        small: commonDataService.language === 'en',
                        medium: commonDataService.language === 'nb',
                    }"
                    [(ngModel)]="orderBy"
                    name="sortTickets"
                    (change)="sortTickets(orderBy)">
                    <ng-option [value]="orderByEnum.lastThreadActivityDesc">
                        {{ orderByEnum.lastThreadActivityDesc | ticketsOrderBy | translate }}
                    </ng-option>
                    <ng-option [value]="orderByEnum.lastThreadActivityAsc">
                        {{ orderByEnum.lastThreadActivityAsc | ticketsOrderBy | translate }}
                    </ng-option>
                    <ng-option [value]="orderByEnum.lastAnyActivityDesc">
                        {{ orderByEnum.lastAnyActivityDesc | ticketsOrderBy | translate }}
                    </ng-option>
                    <ng-option [value]="orderByEnum.lastAnyActivityAsc">
                        {{ orderByEnum.lastAnyActivityAsc | ticketsOrderBy | translate }}
                    </ng-option>
                    <ng-option [value]="orderByEnum.creationTimeDesc">
                        {{ orderByEnum.creationTimeDesc | ticketsOrderBy | translate }}
                    </ng-option>
                    <ng-option [value]="orderByEnum.creationTimeAsc">
                        {{ orderByEnum.creationTimeAsc | ticketsOrderBy | translate }}
                    </ng-option>
                    <ng-option [value]="orderByEnum.importanceDesc">
                        {{ orderByEnum.importanceDesc | ticketsOrderBy | translate }}
                    </ng-option>
                    <ng-option [value]="orderByEnum.importanceAsc">
                        {{ orderByEnum.importanceAsc | ticketsOrderBy | translate }}
                    </ng-option>
                    @if (commonDataService.customerSettings.isSlaEnabled) {
                        <ng-option [value]="orderByEnum.expirationTimeAsc">
                            {{ orderByEnum.expirationTimeAsc | ticketsOrderBy | translate }}
                        </ng-option>
                    }
                    <ng-template ng-footer-tmp>
                        <label
                            class="checkbox__label checkbox__label--size-small lh-base m-1"
                            [class.opacity-50]="isLoadingTickets">
                            {{ 'Hide tickets assigned to other users' | translate }}
                            <input
                                type="checkbox"
                                [(ngModel)]="isUnassignedOrAssignedToMe"
                                (ngModelChange)="handleIsUnassignedOrAssignedToMe()"
                                [disabled]="isLoadingTickets" />
                            <span class="checkbox__checkmark"></span>
                        </label>
                    </ng-template>
                </ng-select>
            </div>

            <div class="vertical-divider"></div>
        }

        <button class="btn btn-icon" tooltip="{{ 'Refresh' | translate }}" (click)="loadMore(true)">
            <sb-inline-svg
                class="icon"
                aria-label="My icon"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Refresh icon.svg'">
            </sb-inline-svg>
        </button>

        <div class="vertical-divider"></div>
    </nav>

    <div class="ticket-list-container d-flex">
        <div class="search-results-container">
            @if (isNoTicketsMatchThisCriteria) {
                <div class="tickets-list-empty text-light">
                    <sb-inline-svg
                        class="icon"
                        aria-label="My icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Search icon.svg'">
                    </sb-inline-svg>
                    <h4 translate>No tickets match these criteria.</h4>
                    <p>
                        <span translate>Please adjust your filters or </span>
                        <a [routerLink]="['/', communityName, 'tickets']" [queryParams]="{}" translate> show all</a>
                        <span translate> tickets. </span>
                    </p>
                </div>
            }

            @if (showEmptyTicketsState) {
                <div class="tickets-list-empty text-light">
                    <sb-inline-svg
                        class="icon"
                        aria-hidden="true"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Ticket icon.svg'">
                    </sb-inline-svg>
                    <h4>{{ emptyTicketsTitle | translate }}</h4>
                </div>
            }

            <div
                class="search-results"
                infiniteScroll
                [infiniteScrollDistance]="2"
                [infiniteScrollThrottle]="50"
                (scrolled)="loadMore()"
                [infiniteScrollContainer]="'.search-results-container'"
                [fromRoot]="true">
                <div class="list-group" (window:keydown)="keyDown($event)">
                    @for (ticket of tickets; track ticket.id) {
                        <app-ticket-list-item
                            class="list-group-item list-group-item-action noselect"
                            [ticket]="ticket"
                            (click)="clickTicket($event, ticket)"
                            [isFeedViewMinimized]="commonDataService.user.isFeedViewMinimized"
                            [changeDetectionMarker]="ticket.changeDetectionMarker"
                            [ngClass]="{
                                active: ticket.isSelected || ticket.id === ticketDetailsPanelService.currentTicketId,
                                expired: ticket.isExpired,
                            }"
                            id="ticket-{{ ticket.id }}">
                        </app-ticket-list-item>
                    }
                </div>
            </div>

            @if (isLoadingTickets) {
                <sb-loader class="mt-2"></sb-loader>
            }
        </div>
        <app-resizer
            id="ticket-resizer"
            resizer="vertical"
            [resizerWidth]="1"
            resizerLeft=".search-results-container"
            resizerRight=".ticket-detail-container"
            [resizerMin]="280"
            [resizerMax]="1500"
            [resizerDependentMin]="500"
            resizerMain=".search-results-container"
            resizerDependent=".ticket-detail-container"
            resizerSide="left">
        </app-resizer>
        <div class="ticket-detail-container flex-fill">
            <div
                id="ticket-detail-panel"
                [ngClass]="{
                    'ticket-detail-panel-cut':
                        rightPanelService.isRightPanelOpened && !ticketRightPanelService.isRightPanelOpened,
                    'ticket-detail-panel-full-cut':
                        rightPanelService.isRightPanelOpened && ticketRightPanelService.isRightPanelOpened,
                }">
                @if (selectedTickets.length) {
                    <app-ticket-bulk-operations
                        [selectedTickets]="selectedTickets"
                        [trackBy]="selectedTickets.length"
                        (ticketsClosed)="handleBulkTicketsClosed($event)">
                    </app-ticket-bulk-operations>
                }
                @if (ticketDetailsPanelService.isTicketDetailsOpened && !selectedTickets.length) {
                    <app-ticket-details> </app-ticket-details>
                }
                @if (showTicketDetailsEmptyState) {
                    <div class="ticket-details-empty-state">
                        <sb-inline-svg
                            class="icon"
                            [attr.aria-label]="'No ticket selected' | translate"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Ticket icon.svg'">
                        </sb-inline-svg>
                        <h3 translate>No ticket selected</h3>
                        <p translate>Choose a ticket to continue</p>
                    </div>
                }
            </div>
            @if (rightPanelService.isRightPanelOpened && !commonDataService.user.isReadOnly) {
                <app-right-panel
                    style="float: right; height: 100%; display: block; overflow-y: auto"
                    class="right-panel">
                </app-right-panel>
            }
        </div>
    </div>
</div>
@if (rightPanelService.isRightPanelOpened) {
    <bs-modal-backdrop
        (click)="rightPanelService.close()"
        class="modal-backdrop modal-backdrop-rightPanel fade in show">
    </bs-modal-backdrop>
}
